'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _constants = require('ui/signature-modal/constants');

var _constants2 = _interopRequireDefault(_constants);

var _signatureModal = require('./signature-modal');

var _signatureModal2 = _interopRequireDefault(_signatureModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

require('./edit-signature-modal.scss');

var EditSignatureModal = _react2['default'].createClass({
    displayName: 'EditSignatureModal',


    propTypes: {
        'app': _react2['default'].PropTypes.object.isRequired, // Application
        'type': _react2['default'].PropTypes.string, // Signature or initials (see SignatureModal.TYPE_*)
        'isMobile': _react2['default'].PropTypes.bool, // Whether it should have mobile behavior
        'initialTab': _react2['default'].PropTypes.string, // The tab shown at first (see SignatureModal.TAB_*)
        'onComplete': _react2['default'].PropTypes.func.isRequired, // Callback to interact with the opener function(signature, insertEverywhere, shouldClose)
        'locales': _react2['default'].PropTypes.array, // Selected locale (list of one)
        'buttonText': _react2['default'].PropTypes.string, // Text to be displayed on the CTA
        'emailGuid': _react2['default'].PropTypes.string // Email guid for signature upload
    },

    //  ----  LIFECYCLE  ----------------------------------

    getDefaultProps: function getDefaultProps() {

        // NOTE: It does not make sense for canInsertEverywhere to be true here
        // since this component is meant to be used outside the signer page.

        return {
            'type': _constants2['default'].TYPE_SIGNATURE,
            'isMobile': false,
            'initialTab': _constants2['default'].TAB_SAVED,
            'settings': {},
            'canInsertEverywhere': false,
            'locales': ['en-US']
        };
    },


    //  ----  RENDERING  ----------------------------------

    render: function render() {

        // Render the signature modal
        return _react2['default'].createElement(
            'div',
            { className: 'm-edit-signature-modal' },
            _react2['default'].createElement(_signatureModal2['default'], this.props)
        );
    }
});

module.exports = EditSignatureModal;


/*****************
 ** WEBPACK FOOTER
 ** ./src/signer/components/common/signature-modal/edit-signature-modal.jsx
 ** module id = 779
 ** module chunks = 0 1
 **/